"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var component_fields_1 = require("@doordash/component-fields");
var component_layer_manager_1 = require("@doordash/component-layer-manager");
var design_language_1 = require("@doordash/design-language");
var React = require("react");
var AddressGoogleQuery_1 = require("./AddressGoogleQuery");
var AutocompleteSizes_1 = require("./AutocompleteSizes");
var styles_1 = require("./styles");
var SuggestionsDropdown_1 = require("./SuggestionsDropdown");
var AddressAutocomplete = /** @class */ (function (_super) {
    __extends(AddressAutocomplete, _super);
    function AddressAutocomplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            addressInput: _this.props.initialInputValue || ''
        };
        _this.inputRef = React.createRef();
        _this.handleChange = function (addressInput) {
            _this.setState({ addressInput: addressInput });
            if (_this.props.onChange) {
                _this.props.onChange();
            }
        };
        _this.handleSelect = function (addressSuggestion) {
            _this.setState({ addressInput: addressSuggestion.printableAddress });
            _this.props.onSelect(addressSuggestion);
        };
        return _this;
    }
    AddressAutocomplete.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, description = _a.description, placeholder = _a.placeholder, isIconHidden = _a.isIconHidden, autocompleteSize = _a.autocompleteSize, suggestionsMatchWidth = _a.suggestionsMatchWidth;
        return (React.createElement(AddressGoogleQuery_1["default"], { value: this.state.addressInput, onChange: this.handleChange, onSelect: this.handleSelect, maxSuggestions: AutocompleteSizes_1.getMaxSuggestions(autocompleteSize) }, function (inputProps, suggestions, errorText) { return (React.createElement(component_layer_manager_1.AnchoredLayer, { position: component_layer_manager_1.AnchoredLayer.Positions.BottomLeft, offset: [0, component_layer_manager_1.AnchoredLayer.Offset.XxxSmall], content: (suggestions.length || errorText) && (React.createElement(SuggestionsDropdown_1["default"], { suggestions: suggestions, errorText: errorText, autocompleteSize: autocompleteSize, maxWidth: suggestionsMatchWidth && _this.inputRef.current
                    ? _this.inputRef.current.offsetWidth
                    : undefined })) },
            React.createElement("div", { ref: suggestionsMatchWidth ? _this.inputRef : undefined },
                React.createElement(component_fields_1.TextField, { isDisabled: inputProps.disabled, onBlur: inputProps.onBlur, onChange: function (value) {
                        return inputProps.onChange({ target: { value: value } });
                    }, onKeyDown: inputProps.onKeyDown, value: inputProps.value, label: label || '', isLabelHidden: !label, placeholder: placeholder || '', description: description || '', renderBeforeContent: isIconHidden
                        ? undefined
                        : function () { return (React.createElement(styles_1.InputIconBox, null,
                            React.createElement(design_language_1.Icon, { type: design_language_1.Icon.Types.Search, size: design_language_1.Icon.Sizes.Small, color: design_language_1.Icon.Colors.SystemGrey80 }))); } })))); }));
    };
    return AddressAutocomplete;
}(React.Component));
exports["default"] = AddressAutocomplete;
